import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Customer } from "../../_models/customer";
import { Dealer } from "../../_models/dealer";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import {
  ToasterModule,
  ToasterService,
  ToasterConfig,
} from "angular2-toaster/angular2-toaster";
import { environment } from "../../../environments/environment";
import { EnvironmentService } from "app/_services";
import { NgForm } from "@angular/forms";
import { ServiceOffersService } from "../../_services/serviceoffers.service";
import { ServiceAddonsService } from "../../_services/serviceaddons.service";
import { CustomersService } from "../../_services/customers.service";
import { TyreAgreementsService } from "../../_services/tyreAgreements.service";
import { StatisticsService } from "../../_services/statistics.service";
import { DealersService } from "../../_services/dealers.service";
import { UserService } from "../../_services/user.service";
import { Agreement } from "../../_models";
//import { Dealer } from '../../_models';
import { TyreAgreement } from "../../_models/tyreAgreement";

@Component({
  selector: "app-tyrehotelcheckout",
  templateUrl: "./tyrehotelcheckout.component.html",
  providers: [
    ServiceOffersService,
    ServiceAddonsService,
    CustomersService,
    TyreAgreementsService,
    StatisticsService,
    DealersService,
    UserService,
  ],
})
export class TyreHotelCheckoutComponent implements OnInit {
  public isLoading: boolean = true;
  public customer: Customer = new Customer();
  private dealerId: string;
  public dealer: Dealer;
  private id: string;
  private email: string;
  private customerid: string = "";
  private errorMessage: string = "";
  public disableEmailField: boolean;
  private confirmation: boolean = false;
  //public customer_data: Customer = new Customer();
  private showSearchByReg: boolean = true;
  public pdf: any = "";
  private subscription: Subscription;
  private tyreAgreement: TyreAgreement;
  private toasterService: ToasterService;
  private isAuthenticated = false;
  private orderType: string;
  private acceptLinkMode: boolean = false;

  //private dealersService: DealersService;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });
  private host: String = environment.host;
  private port: String = environment.port;
  private authenticateUrl = this.environmentService.getBaseURL() + "/";

  constructor(
    toasterService: ToasterService,
    statisticsService: StatisticsService,
    private customersService: CustomersService,
    private dealersService: DealersService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private serviceAddonsService: ServiceAddonsService,
    private modalService: NgbModal,
    private environmentService: EnvironmentService,
    private userService: UserService,
    private tyreAgreementsService: TyreAgreementsService
  ) {
    this.toasterService = toasterService;
    this.activatedRoute = activatedRoute;
  }

  ngOnInit() {

    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        //if (param['regsearch'] && param['regsearch'] == 'false') {
        //  this.showSearchByReg = false;
        //}
        if (param["agreementId"] != null) {
          this.acceptLinkMode = true;
          //this.orderType = "customer";
          this.tyreAgreementsService.get(param["agreementId"]).subscribe(
            (p) => {
              this.tyreAgreement = p;
              this.customer = p.customer;
              this.id = this.tyreAgreement.customer.mauticId.toString();
            },
            (e) => (this.errorMessage = e),
            () => {
              this.initData();
              //this.isLoading = false;
            });
        }
        else {
          this.id = param["id"];
          this.email = param["email"];
          this.orderType = param["orderType"];
          this.tyreAgreement = JSON.parse(sessionStorage.getItem("agree"));
          this.tyreAgreement.sellerInitials = sessionStorage.getItem('sellerInitial');
          this.initData();
          //this.isLoading = false;
        }
      }
    );
    console.log("loaded agreement. linkAccept: " + this.acceptLinkMode + ", ");
  }

  initData() {
    if (this.tyreAgreement != null) {
      this.dealerId = this.tyreAgreement.dealer_id;
    }
    
    let customerLoaded = false;
    let dealerLoaded = false;
    
    const checkIfAllLoaded = () => {
      if (customerLoaded && dealerLoaded) {
        this.isLoading = false;
      }
    };
    
    //console.log(this.tyreAgreement);
    if (this.id != null) {
      this.customersService.getFromMauticContactId(this.dealerId, this.id).subscribe(
        p => this.customer = p,
        e => {
          this.errorMessage = e;
          customerLoaded = true;
          checkIfAllLoaded();
        },
        () => {
          console.log("customer: " + JSON.stringify(this.customer));
          customerLoaded = true;
          checkIfAllLoaded();
        });
    }
    else {
      this.customersService.getFromMauticSegmentAndEmail(195, this.dealerId, this.email).subscribe(
        p => this.customer = p,
        e => {
          this.errorMessage = e;
          customerLoaded = true;
          checkIfAllLoaded();
        },
        () => {
          customerLoaded = true;
          checkIfAllLoaded();
        });
    }

    // Try to get dealer from session storage first
    const storedDealer = sessionStorage.getItem('dealer');
    if (storedDealer) {
      this.dealer = JSON.parse(storedDealer);
      this.disableEmailField = this.dealer.tyreHotelEmailFieldDisabled;
      dealerLoaded = true;
      checkIfAllLoaded();
    } else {
      // Fall back to API call if dealer not in session storage
      this.dealersService.get(this.dealerId).subscribe(
        (p) => (this.dealer = p),
        (e) => (this.errorMessage = e),
        () => {
          //if (this.customer.dealer == null) {
          //  this.customer.dealer = new Array();
          //}
          //console.log('dealer: ' + this.dealer._id);
          //this.customer.dealer[0] = this.dealer;
          this.disableEmailField = this.dealer.tyreHotelEmailFieldDisabled;
          dealerLoaded = true;
          checkIfAllLoaded();
        }
      );
    }
  }

  getNumberOfTyres() {
    var numberOfTyres = 0;

    if (this.tyreAgreement.change_tyre_1) {
      numberOfTyres += 1;
    }
    if (this.tyreAgreement.change_tyre_2) {
      numberOfTyres += 1;
    }
    if (this.tyreAgreement.change_tyre_3) {
      numberOfTyres += 1;
    }
    if (this.tyreAgreement.change_tyre_4) {
      numberOfTyres += 1;
    }

    return numberOfTyres;
  }

  previewTC() {
    if (this.customer._id) {
      this.tyreAgreement.customer = this.customer;
      this.tyreAgreement.order_type = this.orderType;
      this.tyreAgreement.viewPDF = true;
      console.log("updating customer...");
      this.customersService.update(this.customer).subscribe(
        (r) => {},
        (e) => {
          this.errorMessage = e;
          console.log("updating error: " + this.errorMessage);
        },
        () => {
          console.log("creating agreement...");

          if (this.tyreAgreement._id == undefined) {
            this.tyreAgreementsService.create(this.tyreAgreement).subscribe(
              /* happy path */
              (r) => {
                console.log("agreement created. data: " + JSON.stringify(r));
                this.tyreAgreement._id = r._id;
                this.isLoading = false;
                this.tyreAgreement.viewPDF = false;
                this.downloadFile(
                  this.authenticateUrl + "api/agreement/tc_" + r._id + ".pdf",
                  "tc_" + r._id + ".pdf"
                );
              },
              /* error path */
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
                this.tyreAgreement.viewPDF = false;
              }
            );
          } else {
            this.tyreAgreementsService.update(this.tyreAgreement).subscribe(
              /* happy path */
              (r) => {
                console.log("agreement updated. data: " + JSON.stringify(r));
                this.tyreAgreement._id = r._id;
                this.isLoading = false;
                this.tyreAgreement.viewPDF = false;
                this.downloadFile(
                  this.authenticateUrl +
                    "api/agreement/tc_" +
                    this.tyreAgreement._id +
                    ".pdf",
                  "tc_" + this.tyreAgreement._id + ".pdf"
                );
              },
              /* error path */
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
                this.tyreAgreement.viewPDF = false;
              }
            );
          }
        }
      );
    } else {
      console.log("create customer");
      console.log(
        "with dealer: " + this.dealer != null + " id: " + this.dealer.name
      );
      this.customer.dealer = new Array();
      this.customer.dealer[0] = this.dealer;
      this.customersService.create(this.customer).subscribe(
        (r) => (this.customer = r),
        (e) => (this.errorMessage = e),
        () => {
          console.log("create customer done");

          this.previewTC();
        }
      );
    }
  }

  private previewPdf() {
    if (this.customer._id) {
      this.tyreAgreement.customer = this.customer;
      this.tyreAgreement.order_type = this.orderType;
      this.tyreAgreement.viewPDF = true;
      console.log("updating customer...");
      this.customersService.update(this.customer).subscribe(
        (r) => {},
        (e) => {
          this.errorMessage = e;
          console.log("updating error: " + this.errorMessage);
        },
        () => {
          console.log("creating agreement...");

          if (this.tyreAgreement._id == undefined) {
            this.tyreAgreementsService.create(this.tyreAgreement).subscribe(
              /* happy path */
              (r) => {
                this.tyreAgreement._id = r._id;
                console.log("agreement created. data: " + JSON.stringify(r));
                this.isLoading = false;
                this.tyreAgreement.viewPDF = false;
                this.downloadFile(
                  this.authenticateUrl +
                    "api/agreement/offer_" +
                    r._id +
                    ".pdf",
                  "api/agreement/offer_" + r._id + ".pdf"
                );
              },
              /* error path */
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
                this.tyreAgreement.viewPDF = false;
              }
            );
          } else {
            this.tyreAgreementsService.update(this.tyreAgreement).subscribe(
              /* happy path */
              (r) => {
                console.log("agreement updated. data: " + JSON.stringify(r));
                this.tyreAgreement._id = r._id;
                this.isLoading = false;
                this.tyreAgreement.viewPDF = false;
                this.downloadFile(
                  this.authenticateUrl +
                    "api/agreement/offer_" +
                    this.tyreAgreement._id +
                    ".pdf",
                  "api/agreement/offer_" + this.tyreAgreement._id + ".pdf"
                );
              },
              /* error path */
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
                this.tyreAgreement.viewPDF = false;
              }
            );
          }
        }
      );
    } else {
      console.log("create customer");
      console.log(
        "with dealer: " + this.dealer != null + " id: " + this.dealer.name
      );
      this.customer.dealer = new Array();
      this.customer.dealer[0] = this.dealer;
      this.customersService.create(this.customer).subscribe(
        (r) => (this.customer = r),
        (e) => (this.errorMessage = e),
        () => {
          console.log("create customer done");

          this.previewPdf();
        }
      );
    }
    this.isLoading = false;
  }

  private downloadFile(url: string, filename: string) {
    var a = document.createElement("a");
    a.href = url;
    filename = filename;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  private openPdf(tabWindowId: Window, agreement: TyreAgreement) {
    var tabWindowId = window.open("about:blank", "_blank");

    if (this.customer._id) {
      this.tyreAgreement.customer = this.customer;
      this.tyreAgreement.order_type = this.orderType;

      console.log("updating customer...");
      this.customersService.update(this.customer).subscribe(
        (r) => {},
        (e) => {
          this.errorMessage = e;
          console.log("updating error: " + this.errorMessage);
        },
        () => {
          console.log("creating agreement...");

          if (this.tyreAgreement._id == undefined) {
            this.tyreAgreementsService.create(this.tyreAgreement).subscribe(
              /* happy path */
              (r) => {
                this.tyreAgreement = r;
                this.isLoading = false;
                tabWindowId.location.href =
                  this.authenticateUrl +
                  "api/agreement/agreement_" +
                  r._id +
                  ".pdf";
              },
              /* error path */
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
          } else {
            this.tyreAgreementsService.update(this.tyreAgreement).subscribe(
              /* happy path */
              (r) => {
                this.isLoading = false;
                tabWindowId.location.href =
                  this.authenticateUrl +
                  "api/agreement/agreement_" +
                  this.tyreAgreement._id +
                  ".pdf";
              },
              /* error path */
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
          }
        }
      );
    } else {
      console.log("create customer");
      console.log(
        "with dealer: " + this.dealer != null + " id: " + this.dealer.name
      );
      this.customer.dealer = new Array();
      this.customer.dealer[0] = this.dealer;
      this.customersService.create(this.customer).subscribe(
        (r) => (this.customer = r),
        (e) => (this.errorMessage = e),
        () => {
          console.log("create customer done");

          this.previewTC();
        }
      );
    }
    this.isLoading = false;
    //tabWindowId.location.href = this.authenticateUrl + 'api/agreement/agreement_' + agreement._id + '.pdf';
  }

  private openTC(tabWindowId: Window, agreement: TyreAgreement) {
    this.isLoading = false;
    //tabWindowId.location.href = this.authenticateUrl + 'api/agreement/tc_' + agreement._id + '.pdf';
  }

  saveAgreement(checkoutForm: NgForm) {
    checkoutForm.form.disable();
    this.isLoading = true;
    this.tyreAgreement.viewPDF = false;
    if (this.acceptLinkMode || this.orderType.toLowerCase() == "customer") {
      this.tyreAgreement.customerAccept = true;
    }

    this.tyreAgreement.order_completed = true;

    if (this.customer._id) {
      this.tyreAgreement.customer = this.customer;
      this.tyreAgreement.order_type = this.orderType;
      this.tyreAgreement.customerAccept = this.customer.tyre_term != null;

      console.log("updating customer...");
      this.customersService.update(this.customer).subscribe(
        (r) => {},
        (e) => {
          this.errorMessage = e;
          console.log("updating error: " + this.errorMessage);
        },
        () => {
          if (this.tyreAgreement._id != undefined) {
            this.tyreAgreementsService.update(this.tyreAgreement).subscribe(
              (r) => {
                //if (this.acceptLinkMode || this.orderType.toLowerCase() == 'customer') {
                //  this.acceptAgreement();
                //}
                console.log("agreement updated");
                this.agreementDone();
              },
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
                checkoutForm.form.enable();
                console.log("error updating agreement: " + e);
              }
            );
          } else {
            this.tyreAgreementsService.create(this.tyreAgreement).subscribe(
              (r) => {
                console.log("create agreement done");
                //if (this.acceptLinkMode || this.orderType.toLowerCase() == 'customer') {
                //  this.acceptAgreement();
                //}
                this.agreementDone();
                this.tyreAgreement = r;
                console.log("Agreement updated");
              },
              (e) => {
                console.log("create agreement error: " + e);
                this.errorMessage = e;
                this.isLoading = false;
                checkoutForm.form.enable();
                console.log("error creating agreement: " + e);
              }
            );
          }
        }
      );
    } else {
      console.log("create customer");
      console.log(
        "with dealer: " + this.dealer != null + " id: " + this.dealer.name
      );
      this.customer.dealer = new Array();
      this.customer.dealer[0] = this.dealer;
      this.customersService.create(this.customer).subscribe(
        (r) => (this.customer = r),
        (e) => (this.errorMessage = e),
        () => {
          console.log("create customer done");

          console.log(
            ("with dealer: " + this.customer.dealer !=
              null + " id: " + this.customer.dealer[0]) !=
              null
              ? this.customer.dealer[0].name
              : "no dealer"
          );
          this.tyreAgreement.customer = this.customer;

          //Hack for now
          //this.agreementDone();

          this.tyreAgreementsService.create(this.tyreAgreement).subscribe(
            (r) => {
              console.log("create agreement done");
              //if (this.acceptLinkMode || this.orderType.toLowerCase() == 'customer') {
              //  this.acceptAgreement();
              //}
              this.agreementDone();
              this.tyreAgreement = r;
            },
            (e) => {
              console.log("create agreement error " + e);
              this.errorMessage = e;
              this.isLoading = false;
              checkoutForm.form.enable();
            }
          );
        }
      );
    }
  }

  acceptAgreement() {
    this.tyreAgreementsService
      .acceptAgreement(
        this.tyreAgreement,
        this.dealer,
        this.customer.mauticId.toString()
      )
      .subscribe(
        (r) => {
          var agreement = r;
        },
        (e) => {
          this.errorMessage = e;
        },
        () => {
          this.agreementDone();
        }
      );
  }

  agreementDone() {
    sessionStorage.removeItem("agree");
    sessionStorage.removeItem("dealer");
    this.confirmation = true;
    this.isLoading = false;
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/tyrehotelcheckout/tyrehotelcheckout.component.ts